import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import EntityPanel from "src/components/entityPanel";
import { fetchGroup } from "src/redux/actions/groups";

import styles from "./assetsListPanel.module.scss";
import cx from "classnames";
import _ from "lodash";

interface AssetsListPanelProps {
  toggleShow: () => void;
  selected: any;
}

const AssetsListPanel: React.FC<AssetsListPanelProps> = ({
  toggleShow,
  selected,
}) => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const source = searchParams.get("source");

  const sourceId = source?.startsWith("groups/") ? source.split("/")[1] : null;
  const sourceType = source?.startsWith("groups/") ? "group" : null;

  const sourceItem = useSelector((state: any) =>
    _.get(state, `${sourceType}.${sourceId}.item`, []),
  );

  const loading = useSelector((state: any) =>
    _.get(state, `${sourceType}.${sourceId}.loading`, false),
  );

  useEffect(() => {
    if (sourceType && sourceId) {
      if (_.size(sourceItem) > 0) {
        return;
      }

      if (sourceType === "group") {
        dispatch(fetchGroup({ id: sourceId }));
      }
    }
  }, [sourceType, sourceId]);


  const onSelection = (id: string) => {
    navigate(`/assets/${id}?source=groups/${sourceId}`);
  };

  return (
    <div className={cx(styles.assetsListPanelContainer)}>
      <span className={styles.closeIconContainer} onClick={toggleShow}>
        <i className={cx("paperflite-close", styles.closeIcon)} />
      </span>
      <EntityPanel
        items={[sourceItem]}
        selected={selected}
        loading={loading}
        onSelection={onSelection}
      />
    </div>
  );
};

export default AssetsListPanel;
